// Preset avatars optimized for thermal printing (bold black on white, high contrast)
// Each is an inline SVG data URI

const sw = '5'; // thick strokes for thermal printing
const fill = '#000';
const bg = '#ffffff';

function makeSvg(content) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
  <rect width="200" height="200" fill="${bg}"/>
  ${content}
</svg>`;
  return 'data:image/svg+xml,' + encodeURIComponent(svg);
}

const PRESET_AVATARS = [
  // 1. Bull (stock market bull)
  makeSvg(`
    <circle cx="100" cy="95" r="35" stroke="${fill}" stroke-width="${sw}" fill="none"/>
    <circle cx="88" cy="88" r="4" fill="${fill}"/>
    <circle cx="112" cy="88" r="4" fill="${fill}"/>
    <ellipse cx="100" cy="102" rx="12" ry="7" stroke="${fill}" stroke-width="3" fill="none"/>
    <circle cx="95" cy="101" r="2" fill="${fill}"/>
    <circle cx="105" cy="101" r="2" fill="${fill}"/>
    <path d="M65,75 Q60,50 55,45" stroke="${fill}" stroke-width="${sw}" fill="none" stroke-linecap="round"/>
    <path d="M135,75 Q140,50 145,45" stroke="${fill}" stroke-width="${sw}" fill="none" stroke-linecap="round"/>
    <line x1="100" y1="130" x2="100" y2="160" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <line x1="100" y1="160" x2="80" y2="185" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <line x1="100" y1="160" x2="120" y2="185" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
  `),

  // 2. Bear (stock market bear)
  makeSvg(`
    <circle cx="100" cy="95" r="38" stroke="${fill}" stroke-width="${sw}" fill="none"/>
    <circle cx="78" cy="62" r="12" stroke="${fill}" stroke-width="4" fill="none"/>
    <circle cx="122" cy="62" r="12" stroke="${fill}" stroke-width="4" fill="none"/>
    <circle cx="90" cy="90" r="4" fill="${fill}"/>
    <circle cx="110" cy="90" r="4" fill="${fill}"/>
    <ellipse cx="100" cy="108" rx="10" ry="6" stroke="${fill}" stroke-width="3" fill="${fill}"/>
    <path d="M88,118 Q100,128 112,118" stroke="${fill}" stroke-width="3" fill="none" stroke-linecap="round"/>
    <line x1="100" y1="133" x2="100" y2="165" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <line x1="100" y1="165" x2="78" y2="188" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <line x1="100" y1="165" x2="122" y2="188" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
  `),

  // 3. Robot trader
  makeSvg(`
    <rect x="72" y="50" width="56" height="50" rx="6" stroke="${fill}" stroke-width="${sw}" fill="none"/>
    <rect x="82" y="68" width="14" height="10" rx="2" stroke="${fill}" stroke-width="3" fill="${fill}"/>
    <rect x="104" y="68" width="14" height="10" rx="2" stroke="${fill}" stroke-width="3" fill="${fill}"/>
    <line x1="88" y1="90" x2="112" y2="90" stroke="${fill}" stroke-width="3" stroke-linecap="round"/>
    <line x1="72" y1="60" x2="62" y2="45" stroke="${fill}" stroke-width="4" stroke-linecap="round"/>
    <circle cx="60" cy="42" r="4" fill="${fill}"/>
    <line x1="128" y1="60" x2="138" y2="45" stroke="${fill}" stroke-width="4" stroke-linecap="round"/>
    <circle cx="140" cy="42" r="4" fill="${fill}"/>
    <line x1="100" y1="100" x2="100" y2="145" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <line x1="100" y1="110" x2="65" y2="125" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <line x1="100" y1="110" x2="135" y2="125" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <line x1="100" y1="145" x2="78" y2="182" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <line x1="100" y1="145" x2="122" y2="182" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
  `),

  // 4. Cat face
  makeSvg(`
    <circle cx="100" cy="105" r="40" stroke="${fill}" stroke-width="${sw}" fill="none"/>
    <polygon points="68,72 60,30 88,62" stroke="${fill}" stroke-width="4" fill="none" stroke-linejoin="round"/>
    <polygon points="132,72 140,30 112,62" stroke="${fill}" stroke-width="4" fill="none" stroke-linejoin="round"/>
    <circle cx="85" cy="98" r="5" fill="${fill}"/>
    <circle cx="115" cy="98" r="5" fill="${fill}"/>
    <polygon points="100,112 96,116 104,116" fill="${fill}"/>
    <path d="M96,120 Q88,128 78,122" stroke="${fill}" stroke-width="3" fill="none" stroke-linecap="round"/>
    <path d="M104,120 Q112,128 122,122" stroke="${fill}" stroke-width="3" fill="none" stroke-linecap="round"/>
    <line x1="58" y1="95" x2="40" y2="90" stroke="${fill}" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="58" y1="105" x2="38" y2="105" stroke="${fill}" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="142" y1="95" x2="160" y2="90" stroke="${fill}" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="142" y1="105" x2="162" y2="105" stroke="${fill}" stroke-width="2.5" stroke-linecap="round"/>
  `),

  // 5. Rocket
  makeSvg(`
    <ellipse cx="100" cy="85" rx="22" ry="50" stroke="${fill}" stroke-width="${sw}" fill="none"/>
    <path d="M78,110 L60,140 L82,125" stroke="${fill}" stroke-width="4" fill="none" stroke-linejoin="round"/>
    <path d="M122,110 L140,140 L118,125" stroke="${fill}" stroke-width="4" fill="none" stroke-linejoin="round"/>
    <circle cx="100" cy="75" r="8" stroke="${fill}" stroke-width="3" fill="none"/>
    <path d="M88,135 Q94,155 100,160 Q106,155 112,135" stroke="${fill}" stroke-width="4" fill="none" stroke-linecap="round"/>
    <line x1="95" y1="160" x2="90" y2="180" stroke="${fill}" stroke-width="3" stroke-linecap="round"/>
    <line x1="100" y1="162" x2="100" y2="185" stroke="${fill}" stroke-width="3" stroke-linecap="round"/>
    <line x1="105" y1="160" x2="110" y2="180" stroke="${fill}" stroke-width="3" stroke-linecap="round"/>
  `),

  // 6. Diamond
  makeSvg(`
    <polygon points="100,25 155,90 100,175 45,90" stroke="${fill}" stroke-width="${sw}" fill="none" stroke-linejoin="round"/>
    <line x1="45" y1="90" x2="155" y2="90" stroke="${fill}" stroke-width="3"/>
    <line x1="100" y1="25" x2="72" y2="90" stroke="${fill}" stroke-width="2.5"/>
    <line x1="100" y1="25" x2="128" y2="90" stroke="${fill}" stroke-width="2.5"/>
    <line x1="72" y1="90" x2="100" y2="175" stroke="${fill}" stroke-width="2.5"/>
    <line x1="128" y1="90" x2="100" y2="175" stroke="${fill}" stroke-width="2.5"/>
  `),

  // 7. Skull (edgy trader)
  makeSvg(`
    <circle cx="100" cy="85" r="42" stroke="${fill}" stroke-width="${sw}" fill="none"/>
    <circle cx="84" cy="78" r="12" stroke="${fill}" stroke-width="4" fill="${fill}"/>
    <circle cx="116" cy="78" r="12" stroke="${fill}" stroke-width="4" fill="${fill}"/>
    <circle cx="84" cy="78" r="5" fill="${bg}"/>
    <circle cx="116" cy="78" r="5" fill="${bg}"/>
    <polygon points="100,95 96,108 104,108" fill="${fill}"/>
    <line x1="84" y1="118" x2="116" y2="118" stroke="${fill}" stroke-width="3" stroke-linecap="round"/>
    <line x1="90" y1="114" x2="90" y2="122" stroke="${fill}" stroke-width="2.5"/>
    <line x1="100" y1="114" x2="100" y2="122" stroke="${fill}" stroke-width="2.5"/>
    <line x1="110" y1="114" x2="110" y2="122" stroke="${fill}" stroke-width="2.5"/>
    <rect x="88" y="127" width="24" height="40" rx="4" stroke="${fill}" stroke-width="4" fill="none"/>
  `),

  // 8. Crown (king trader)
  makeSvg(`
    <circle cx="100" cy="110" r="38" stroke="${fill}" stroke-width="${sw}" fill="none"/>
    <circle cx="88" cy="104" r="4" fill="${fill}"/>
    <circle cx="112" cy="104" r="4" fill="${fill}"/>
    <path d="M88,120 Q100,132 112,120" stroke="${fill}" stroke-width="3" fill="none" stroke-linecap="round"/>
    <polyline points="60,72 60,40 78,56 100,30 122,56 140,40 140,72" stroke="${fill}" stroke-width="${sw}" fill="none" stroke-linejoin="round" stroke-linecap="round"/>
    <line x1="60" y1="72" x2="140" y2="72" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <circle cx="60" cy="38" r="4" fill="${fill}"/>
    <circle cx="100" cy="28" r="4" fill="${fill}"/>
    <circle cx="140" cy="38" r="4" fill="${fill}"/>
  `),

  // 9. Lightning bolt
  makeSvg(`
    <polygon points="110,15 70,100 95,100 85,185 140,88 112,88" stroke="${fill}" stroke-width="${sw}" fill="none" stroke-linejoin="round"/>
  `),

  // 10. Dollar sign bold
  makeSvg(`
    <text x="100" y="150" font-size="160" font-weight="900" fill="none" stroke="${fill}" stroke-width="5" font-family="Arial, sans-serif" text-anchor="middle">$</text>
  `),

  // 11. Alien
  makeSvg(`
    <ellipse cx="100" cy="90" rx="45" ry="55" stroke="${fill}" stroke-width="${sw}" fill="none"/>
    <ellipse cx="82" cy="82" rx="15" ry="10" stroke="${fill}" stroke-width="3" fill="${fill}"/>
    <ellipse cx="118" cy="82" rx="15" ry="10" stroke="${fill}" stroke-width="3" fill="${fill}"/>
    <ellipse cx="82" cy="82" rx="6" ry="4" fill="${bg}"/>
    <ellipse cx="118" cy="82" rx="6" ry="4" fill="${bg}"/>
    <ellipse cx="100" cy="110" rx="6" ry="3" stroke="${fill}" stroke-width="2.5" fill="none"/>
    <line x1="100" y1="145" x2="100" y2="170" stroke="${fill}" stroke-width="4" stroke-linecap="round"/>
    <line x1="100" y1="155" x2="70" y2="145" stroke="${fill}" stroke-width="3" stroke-linecap="round"/>
    <line x1="100" y1="155" x2="130" y2="145" stroke="${fill}" stroke-width="3" stroke-linecap="round"/>
  `),

  // 12. Smiley
  makeSvg(`
    <circle cx="100" cy="100" r="60" stroke="${fill}" stroke-width="${sw}" fill="none"/>
    <circle cx="78" cy="85" r="7" fill="${fill}"/>
    <circle cx="122" cy="85" r="7" fill="${fill}"/>
    <path d="M70,115 Q100,150 130,115" stroke="${fill}" stroke-width="${sw}" fill="none" stroke-linecap="round"/>
  `),

  // 13. Ghost
  makeSvg(`
    <path d="M60,120 L60,80 Q60,35 100,35 Q140,35 140,80 L140,120 L128,108 L116,120 L104,108 L92,120 L80,108 L68,120 Z" stroke="${fill}" stroke-width="${sw}" fill="none" stroke-linejoin="round"/>
    <circle cx="85" cy="75" r="8" fill="${fill}"/>
    <circle cx="115" cy="75" r="8" fill="${fill}"/>
    <circle cx="85" cy="73" r="3" fill="${bg}"/>
    <circle cx="115" cy="73" r="3" fill="${bg}"/>
    <ellipse cx="100" cy="95" rx="7" ry="5" stroke="${fill}" stroke-width="3" fill="none"/>
  `),

  // 14. Ninja
  makeSvg(`
    <circle cx="100" cy="85" r="40" stroke="${fill}" stroke-width="${sw}" fill="none"/>
    <rect x="60" y="72" width="80" height="18" rx="2" stroke="${fill}" stroke-width="4" fill="${fill}"/>
    <circle cx="85" cy="81" r="5" fill="${bg}"/>
    <circle cx="115" cy="81" r="5" fill="${bg}"/>
    <line x1="140" y1="76" x2="170" y2="65" stroke="${fill}" stroke-width="3" stroke-linecap="round"/>
    <line x1="140" y1="82" x2="168" y2="78" stroke="${fill}" stroke-width="3" stroke-linecap="round"/>
    <line x1="100" y1="125" x2="100" y2="160" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <line x1="100" y1="135" x2="65" y2="118" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <line x1="100" y1="135" x2="135" y2="118" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <line x1="100" y1="160" x2="78" y2="188" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
    <line x1="100" y1="160" x2="122" y2="188" stroke="${fill}" stroke-width="${sw}" stroke-linecap="round"/>
  `),

  // 15. Pirate
  makeSvg(`
    <circle cx="100" cy="100" r="40" stroke="${fill}" stroke-width="${sw}" fill="none"/>
    <path d="M60,70 Q60,40 100,35 Q140,40 140,70" stroke="${fill}" stroke-width="4" fill="${fill}"/>
    <line x1="55" y1="70" x2="145" y2="70" stroke="${fill}" stroke-width="4" stroke-linecap="round"/>
    <circle cx="85" cy="92" r="5" fill="${fill}"/>
    <rect x="105" y="82" width="22" height="18" rx="3" stroke="${fill}" stroke-width="3" fill="${fill}"/>
    <line x1="116" y1="82" x2="116" y2="72" stroke="${fill}" stroke-width="3" stroke-linecap="round"/>
    <path d="M85,115 Q100,128 115,115" stroke="${fill}" stroke-width="3" fill="none" stroke-linecap="round"/>
    <text x="93" y="65" font-size="22" font-weight="900" fill="${bg}" font-family="sans-serif">☠</text>
  `),

  // 16. Heart
  makeSvg(`
    <path d="M100,160 L45,100 Q30,70 60,55 Q90,42 100,70 Q110,42 140,55 Q170,70 155,100 Z" stroke="${fill}" stroke-width="${sw}" fill="none" stroke-linejoin="round"/>
  `),

  // 17. Star
  makeSvg(`
    <polygon points="100,20 120,75 180,80 135,120 148,178 100,148 52,178 65,120 20,80 80,75" stroke="${fill}" stroke-width="${sw}" fill="none" stroke-linejoin="round"/>
  `),

  // 18. Owl
  makeSvg(`
    <ellipse cx="100" cy="100" rx="45" ry="50" stroke="${fill}" stroke-width="${sw}" fill="none"/>
    <circle cx="80" cy="88" r="18" stroke="${fill}" stroke-width="4" fill="none"/>
    <circle cx="120" cy="88" r="18" stroke="${fill}" stroke-width="4" fill="none"/>
    <circle cx="80" cy="88" r="7" fill="${fill}"/>
    <circle cx="120" cy="88" r="7" fill="${fill}"/>
    <circle cx="80" cy="86" r="3" fill="${bg}"/>
    <circle cx="120" cy="86" r="3" fill="${bg}"/>
    <polygon points="100,100 95,112 105,112" fill="${fill}"/>
    <path d="M62,60 L72,72" stroke="${fill}" stroke-width="4" stroke-linecap="round"/>
    <path d="M138,60 L128,72" stroke="${fill}" stroke-width="4" stroke-linecap="round"/>
    <path d="M80,140 L80,165 L90,155" stroke="${fill}" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M120,140 L120,165 L110,155" stroke="${fill}" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  `),
];

export default PRESET_AVATARS;
